import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationKO from '../../../locales/ko.json';
import translationEN from '../../../locales/en.json';
import {
  resolveInitialAppLanguage,
  setLangCookie,
} from './languageConstants';

const initialLanguage = resolveInitialAppLanguage();

i18n.use(initReactI18next).init({
  resources: {
    ko: {
      translation: translationKO,
    },
    en: {
      translation: translationEN,
    },
  },
  lng: initialLanguage,
  fallbackLng: 'ko',
  interpolation: {
    escapeValue: false,
  },
});

setLangCookie(initialLanguage);
if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLanguage;
}

export default i18n;
